import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

const initialState = {
    news: [],
    loading: false,
    error: null,
};

export const fetchNewsAsync = createAsyncThunk(
    "news/fetchNews",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("/news/getNews");
            return response.data || response;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch news");
        }
    }
);

const newsSlice = createSlice({
    name: "news",
    initialState,
    reducers: {
        clearNews: (state) => {
            state.news = [];
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNewsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNewsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.news = action.payload;
                state.error = null;
            })
            .addCase(fetchNewsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearNews } = newsSlice.actions;
export default newsSlice.reducer;
